module.exports = __webpack_public_path__ + "img/symbol_4.6f839092.png";